module.exports = __webpack_public_path__ + "media/img/frontend_application/banner-sgbrideonthehunt2-sm-989a2c9636216aaba1dcbb736525bcbd.png";